// @flow
import React, { Component } from 'react';
import { injectIntl, type IntlShape } from 'react-intl';

import type { FieldDefinition } from 'state/types';
import { displayNameForField } from 'util/fieldsPageUtils';

type Props = {
  fieldDef: FieldDefinition,
  intl: IntlShape,
  onDoubleClick: string => void,
};

class Field extends Component<Props> {
  handleDoubleClick: Function;

  constructor() {
    super();

    this.handleDoubleClick = this.handleDoubleClick.bind(this);
  }

  handleDoubleClick() {
    const {
      fieldDef: { id },
      onDoubleClick,
    } = this.props;
    onDoubleClick(id);
  }

  render() {
    const { fieldDef, intl } = this.props;
    return (
      <div onDoubleClick={this.handleDoubleClick}>
        {displayNameForField(intl, fieldDef.systemName)}
      </div>
    );
  }
}

export default injectIntl(Field);



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/ManagedFields/Field.js